export default __webpack_public_path__ + "static/media/logononame.c7c3583e.png";